import { Route } from '@angular/router';
import { SustainabilityDashboardStaticComponent } from './sustainability-dashboard-static.component';

export const SustainabilityDashboardRoutes: Route = {
  path: '',
  component: SustainabilityDashboardStaticComponent,
  children: [
    {
      path: '',
      pathMatch: 'full',
      redirectTo: 'home_',
    },
    {
      path: 'home_',
      loadComponent: () =>
        import('./components/sustainability-dashboard-static-home/sustainability-dashboard-home.component').then(
          (m) => m.SustainabilityDashboardHomeComponent
        ),
    },
    {
      path: 'soil',
      loadComponent: () =>
        import('./components/sustainability-dashboard-static-soil/sustainability-dashboard-soil.component').then(
          (m) => m.SustainabilityDashboardSoilComponent
        ),
    },
    {
      path: 'climate',
      loadComponent: () =>
        import('./components/sustainability-dashboard-static-climate/sustainability-dashboard-climate.component').then(
          (m) => m.SustainabilityDashboardClimateComponent
        ),
    },
    {
      path: 'water',
      loadComponent: () =>
        import('./components/sustainability-dashboard-static-water/sustainability-dashboard-water.component').then(
          (m) => m.SustainabilityDashboardWaterComponent
        ),
    },
    {
      path: 'biodiversity',
      loadComponent: () =>
        import('./components/sustainability-dashboard-static-biodiversity/sustainability-dashboard-biodiversity.component').then(
          (m) => m.SustainabilityDashboardBiodiversityComponent
        ),
    },
    {
      path: 'livelihood',
      loadComponent: () =>
        import('./components/sustainability-dashboard-static-livelihood/sustainability-dashboard-livelihood.component').then(
          (m) => m.SustainabilityDashboardLivelihoodComponent
        ),
    },
  ],
};
